import { BoldText } from "~/components/ui/text";
import { PostGrid } from "../../../components/PostGrid";
import { usePostsContext } from "../../../Provider/context";
import { onMount } from "solid-js";
import { config } from "~/config";

export function Root() {
	const { posts } = usePostsContext();

	const onClickPost = (id: string) => {

		const { posts } = config.moduleConfig ?? {}; 
		const redirectPost: string = posts?.["recent-post-redirect-url"] ?? "";

		const url = new URL(redirectPost);
	
		url.searchParams.set("post", id);
		window.location.href = url.toString();
	};

	onMount(() => {
		const { posts } = config.moduleConfig ?? {}; 
		const redirectPost = posts?.["recent-post-redirect-url"];

		if(!posts || !redirectPost) {
			console.error("No config found for post module. This widget will not work.");
			return;
		}
	});

	return (
		<>
			<BoldText class="text-2xl mb-6">
				Actuele berichten
			</BoldText>
			<PostGrid 
				posts={posts}
				onClickPost={onClickPost}
			/>
		</>
	);
}